export enum ReportType {
	CONSUMPTION = 'CONSUMPTION',
	ACTIVE_USERS = 'ACTIVE_USERS'
}
